<template>
  <v-dialog v-model="isOpen" max-width="500">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <div>
          {{ $t("instructions.instructionsDialog.assignedNames.title") }}
        </div>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent="onSubmit">
          <v-row>
            <v-col cols="10">
              <v-combobox
                ref="nameBox"
                v-model="nameInput"
                :search-input.sync="nameSearch"
                :items="employeeNameOptions"
                :loading="employeesLoading"
                :label="$t('instructions.instructionsDialog.form.name')"
                :placeholder="
                  $t('instructions.instructionsDialog.form.placeholder')
                "
                :rules="nameRules"
                outlined
                clearable
                hide-no-data
              />
            </v-col>

            <v-col cols="2" class="d-flex align-center">
              <v-btn icon type="submit">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

        <v-list>
          <template v-for="(assignedName, index) of assignedNames">
            <v-list-item :key="assignedName">
              <v-list-item-content>
                {{ assignedName }}
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="deleteAssignedName(index)">
                  <v-icon color="grey lighten-1">mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider
              v-if="index < assignedNames.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="isOpen = false">
          {{ $t("general.back") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "instructionTableAssignedNamesDialog",
  props: ["assignedNames"],

  data() {
    return {
      isOpen: false,
      nameInput: null,
      nameSearch: "",
      employeesLoading: false,
      employees: [],
    };
  },

  computed: {
    employeeNameOptions() {
      const assigned = new Set(
        (this.assignedNames || []).map((n) => String(n).trim().toLowerCase()),
      );

      return (this.employees || [])
        .map((e) => e.name)
        .filter(Boolean)
        .filter((name) => !assigned.has(String(name).trim().toLowerCase()))
        .sort((a, b) => a.localeCompare(b));
    },

    nameRules() {
      return [() => !!this.getNormalizedName() || this.$t("general.fieldNeedsToBeFilled")];
    },
  },

  methods: {
    async openDialog() {
      this.isOpen = true;
      await this.fetchEmployees();
    },

    async fetchEmployees() {
      try {
        this.employeesLoading = true;
        const list = await this.$store.dispatch("getAllEmployees");
        this.employees = list || [];
      } finally {
        this.employeesLoading = false;
      }
    },

    getNormalizedName() {
      return String(this.nameSearch || this.nameInput || "").trim();
    },

    onSubmit() {
      const name = this.getNormalizedName();

      if (!name) {
        this.$refs.form.validate();
        return;
      }

      this.$emit("saveInstruction", [name, ...this.assignedNames]);

      this.nameInput = null;
      this.nameSearch = "";
      this.$refs.form.resetValidation();
    },

    deleteAssignedName(index) {
      const copyAssignedNames = [...this.assignedNames];
      copyAssignedNames.splice(index, 1);
      this.$emit("saveInstruction", copyAssignedNames);
    },
  },
};
</script>
